export default class Organization {
    constructor(model) {
        this.id = (model && model.id) || null;
        this.internal = (model && model.internal) || null;
        this.name = (model && model.name) || {};
    };
}
